<script>
export default {
    props: {
        id: Number,
        excludeSwitch: Boolean,
    },
    methods: {
        add() {
            this.$emit("removePromiseToPay", { id: this.id, value: true }); // Emit id and value
        },

        exclude() {
            this.$emit("removePromiseToPay", { id: this.id, value: false }); // Emit id and value
        },
    },
};
</script>

<template>
    <button
        type="button" class="btn btn-outline-success waves-effect waves-light float-end"
        :id="id"
        @click="excludeSwitch ? exclude() : add()"
    >
        {{ excludeSwitch ? 'Revert' : 'Remove P2P' }}
    </button>
</template>
